import { axiosDelete, axiosGet, axiosPost } from "./axiosService";
import environment from "@/constants/Environment";

const BASE_AUTH_URL = "https://auth.atlassian.com";
const environmentData = environment();

export function loginConfluence(freshLogin: boolean = false): Window | null {
  const prevUrl = String(window.location.pathname);
  const clientId = String(environmentData.CONFLUENCE_CLIENT_ID);
  const scopes = [
    "read:me",
    "read:space:confluence",
    "read:page:confluence",
    "offline_access", // req for refreshToken
  ];

  const query = new URLSearchParams({
    audience: "api.atlassian.com",
    client_id: clientId,
    scope: scopes.join(" "),
    redirect_uri: window.location.origin + "/authorize/confluence",
    state: `{"prevUrl": "${prevUrl}"}`,
    response_type: "code",
  });

  if (freshLogin) query.append("prompt", "login");
  else query.append("prompt", "consent");

  const width = 600;
  const height = 700;
  const left =
    (window.screenX || window.screenLeft) + window.outerWidth / 2 - width / 2;
  const top =
    (window.screenY || window.screenTop) +
    window.outerHeight / 2 -
    height / 2 -
    15;

  const authWindow = window.open(
    `${BASE_AUTH_URL}/authorize?${query}`,
    "_blank",
    `width=${width},height=${height},left=${left},top=${top}`,
  );

  return authWindow;
}

export async function getConfluenceConfigs() {
  const response = await axiosGet("/integration/confluence/getAppConfig");
  return response?.data;
}

export async function getConfluenceContentPieces(authId: string) {
  const response = await axiosGet(
    `/integration/confluence/getContentPieces?authId=${authId}`,
  );
  return response?.data?.data;
}

export async function setConfluenceConfig(code: string) {
  await axiosPost(`/integration/confluence/setAppConfig`, { code });
}

export async function logoutConfluence(authId: string) {
  await axiosDelete(`/integration/confluence/deleteAppConfig?authId=${authId}`);
}

export async function extractConfluenceContent(
  selectedContent: any[],
  authId: string,
) {
  const response = await axiosPost(
    `/integration/confluence/extractContent?authId=${authId}`,
    selectedContent,
  );
  return response?.data;
}
